// eslint-disable-next-line unused-imports/no-unused-imports
import { AddToCartButtonType } from '@commerce-cart-webcomponents/ui-composite';
import { FC } from 'react';
import AddToCartButton from '../../AddToCartButton/AddToCartButton';
import { AddToCartWithStepper } from '../../AddToCartWithStepper/AddToCartWithStepper';
import { AddToCartWithSubscribe } from '../../AddToCartWithSubscribe/AddToCartWithSubscribe';
import { type AddToCartOrGroupCartProps } from './types/propsTypes';

const AddToCartOrGroupCartContainer: FC<AddToCartOrGroupCartProps> = (props) => (
  <div data-testid="add-to-cart-or-group-cart-container">
    {props.addToCartButtonType === AddToCartButtonType.ADD_TO_CART_BUTTON && <AddToCartButton {...props} />}
    {props.addToCartButtonType === AddToCartButtonType.ADD_TO_CART_WITH_SUBSCRIBE && (
      <AddToCartWithSubscribe {...props} />
    )}
    {![AddToCartButtonType.ADD_TO_CART_BUTTON, AddToCartButtonType.ADD_TO_CART_WITH_SUBSCRIBE].includes(
      props.addToCartButtonType!,
    ) && <AddToCartWithStepper {...props} />}
  </div>
);

export default AddToCartOrGroupCartContainer;
export type { AddToCartOrGroupCartProps };
